const state = () => {
  return {
    selectedInquiry: {
      inquiryId: 0, // key
      questionDate: '', // 접수일
      status: '', // 처리상태
      title: '', // 문의 제목
      content: '', // 문의 내용
      orderNo: null, // 주문 번호
      productName: '', // 상품명
      productNo: '', // 상품번호
      productOrderNoList: null, // 상품 주문 번호
      writerId: '', // 질문자 ID
      writerName: null, // 질문자 이름
      questionNo: '', //
      category: null, // 문의 유형
      inquiryAnswers: [
        // 답변정보
        {
          answerId: 0, //  key
          answerDate: '', // 답변날짜
          content: '', // 답변내용
          writerId: '', // 답변자 ID
          writerName: '', // 답변자 이름
          answerNo: null
        }
      ]
    }
  };
};

const getters = {
  getInquiry: (state) => {
    return state.selectedInquiry;
  }
};

const mutations = {
  resetSelectedInquiry(state) {
    state.selectedInquiry = {};
  },
  setSelectedInquiry(state, selectedInquiry) {
    state.selectedInquiry = selectedInquiry;
  }
};

export default {
  state,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/inquiry/index.js